module.exports = __webpack_public_path__ + "img/example5.beececb1.jpg";